module.exports = __webpack_public_path__ + "img/s00178.4c4f61d5.png";